import React from 'react';
import { ArrowRight, Shield, BarChart3 } from 'lucide-react';

interface AdminSpotlightSectionProps {
  onLinkClick: (href: string, e: React.MouseEvent) => void;
}

const adminSpotlight = {
  name: "Executive Dashboard",
  tagline: "Real-Time Intelligence",
  description: "Comprehensive system overview with real-time metrics, user analytics, and operational insights.",
  icon: BarChart3,
  image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=900&q=80",
  href: "/admin",
  cta: "Access Dashboard",
};

export const AdminSpotlightSection: React.FC<AdminSpotlightSectionProps> = ({ onLinkClick }) => {
  return (
    <div className="flex-1 px-6 py-4 flex flex-col justify-start items-start bg-gradient-to-b from-white/99 to-gray-50 relative min-w-[320px] gap-2">
      {/* Executive Dashboard Spotlight */}
      <div className="w-full">
        <div className="flex items-center mb-3">
          <adminSpotlight.icon className="w-8 h-8 text-gray-900 mr-3" />
          <span className="text-xl font-semibold text-gray-800 tracking-tight">{adminSpotlight.name}</span>
        </div>
        <span className="block text-sm font-medium text-blue-600 mb-2 tracking-wide">{adminSpotlight.tagline}</span>
        <p className="text-sm text-gray-700 mb-3 leading-relaxed max-w-sm">{adminSpotlight.description}</p>
        <button
          onClick={(e) => onLinkClick(adminSpotlight.href, e)}
          className="text-sm px-6 py-2 shadow-sm bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white font-semibold transition-all duration-150 rounded inline-flex items-center"
        >
          {adminSpotlight.cta}
          <ArrowRight className="ml-2 w-4 h-4" />
        </button>
        {adminSpotlight.image && (
          <img
            src={adminSpotlight.image}
            alt={adminSpotlight.name}
            className="mt-4 w-full object-cover max-h-28 shadow-xl border border-gray-100"
            style={{ objectFit: 'cover' }}
          />
        )}
      </div>

      {/* Security Center Quick Access */}
      <div className="mt-2 w-full flex">
        <button 
          onClick={(e) => onLinkClick('/admin?tab=security', e)}
          className="text-base px-6 py-3 font-semibold w-full shadow-md rounded bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white border-0 transition-all duration-300 hover:shadow-lg inline-flex items-center justify-center"
        >
          <Shield className="mr-2 w-5 h-5" />
          Security Center
          <ArrowRight className="ml-2 w-5 h-5" />
        </button>
      </div>

      {/* Price Beat Guarantee equivalent - Admin Guarantee */}
      <div className="mt-2 w-full">
        <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg p-3">
          <div className="flex items-center">
            <Shield className="w-4 h-4 text-green-600 mr-2" />
            <span className="text-sm font-medium text-green-800">Enterprise Security</span>
          </div>
          <p className="text-xs text-green-700 mt-1">
            Bank-grade security with 99.9% uptime guarantee and 24/7 monitoring.
          </p>
        </div>
      </div>
    </div>
  );
};